"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-lg" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-lg" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-lg" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="hover:!bg-transparent focus:!bg-transparent inline-flex h-9 items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold transition-all duration-[80ms] ease-[cubic-bezier(0.4,0,0.2,1)] hover:text-primary-active focus:text-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-muted/10 transition-all duration-[80ms] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 flex items-center gap-2" aria-label="Toggle menu">
        <span className="text-sm font-semibold text-foreground">Меню</span>
        {mobileMenuOpen ? <X className="size-6 text-foreground" /> : <Menu className="size-6 text-foreground" />}
      </button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b border-border shadow-soft md:hidden">
          <nav className="container py-4 flex flex-col gap-2">
            {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="px-4 py-3 rounded-lg text-sm font-semibold hover:bg-muted/10 transition-all duration-[80ms] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className="w-full border-b border-border bg-background sticky top-0 z-50 backdrop-blur-md bg-background/95">
      <div className="container mx-auto px-6 md:px-12 lg:px-16 py-4 flex items-center justify-between">
        <Link to="/" className="focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50 rounded-sm">
          <img src="https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/ново–лого.webp" alt="Миш-Маш /интерпред/" className="!w-[77px] !h-[77px]" />
        </Link>

        <MenuProvider menu_id="17" className="flex items-center">
          <HeaderMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}